// src/reporting/pdf/pdfFormatters.js
import dayjs from "lib/dayjs";

export function fmtDate(value) {
  if (!value || !dayjs(value).isValid()) return "—";
  return dayjs(value).format("M/D/YYYY");
}

export function fmtNumber(value, digits = 2) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";

  return n.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function fmtCurrency(value, digits = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";

  return n.toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/**
 * Percent formatter for values already expressed in percent units.
 *
 * Examples:
 *   5      -> 5.000%
 *   0.5    -> 0.500%
 *   1.234  -> 1.234%
 */
export function fmtPct(value, digits = 3) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";

  return `${n.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
}

/**
 * Percent formatter for decimal-form rates.
 *
 * Examples:
 *   0.05    -> 5.000%
 *   0.01234 -> 1.234%
 */
export function fmtPctDecimal(value, digits = 3) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";

  return `${(n * 100).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
}

export function fmtTruncNumber(value, digits = 3) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";

  const factor = 10 ** digits;
  const truncated = Math.trunc(n * factor) / factor;

  return truncated.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function safeText(value) {
  if (value == null || value === "") return "—";
  return String(value);
}

export function safeFilePart(value, fallback = "Report") {
  return String(value || fallback).replace(/[^A-Za-z0-9]+/g, "_");
}